module.exports = __webpack_public_path__ + "static/img/an_5.72fd909.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/an_5.png
// module id = 836
// module chunks = 1